var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStake = function SvgStake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4.767c.45.052.734.508.584.935l-2.198 6.245a.705.705 0 0 1-1.263.14l-.47-.75-8.481 5.3L5.7 11.24a4.76 4.76 0 0 1 1.514-6.56l4.445-2.777-.515-.824a.705.705 0 0 1 .68-1.074L18.4.767ZM9.508 15.248A6.407 6.407 0 0 0 7.163 24l8.63-4.983a4.76 4.76 0 0 0 1.742-6.503l-.823-1.426-7.204 4.16Z",
    fill: "#07C166"
  })));
};
export default SvgStake;